 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import VACUUMDIAGRAMS_COVER from '@/components/vacuumdiagrams_cover'
 import LOVE_1 from '@/components/love_1'
 import VACUUMDIAGRAMS from '@/components/vacuumdiagrams'
 import DED from '@/components/ded'
 import CONTENTS from '@/components/contents'
 import FOR from '@/components/for'
 import PRO from '@/components/pro'
 import PT01 from '@/components/pt01'
 import CH_01 from '@/components/ch_01'
 import CH_02 from '@/components/ch_02'
 import CH_03 from '@/components/ch_03'
 import CH_04 from '@/components/ch_04'
 import CH_05 from '@/components/ch_05'
 import PT02 from '@/components/pt02'
 import CH_06 from '@/components/ch_06'
 import CH_07 from '@/components/ch_07'
 import CH_08 from '@/components/ch_08'
 import CH_09 from '@/components/ch_09'
 import PT03 from '@/components/pt03'
 import CH_10 from '@/components/ch_10'
 import CH_11 from '@/components/ch_11'
 import CH_12 from '@/components/ch_12'
 import PT04 from '@/components/pt04'
 import CH_13 from '@/components/ch_13'
 import CH_14 from '@/components/ch_14'
 import PT05 from '@/components/pt05'
 import CH_15 from '@/components/ch_15'
 import CH_16 from '@/components/ch_16'
 import CH_17 from '@/components/ch_17'
 import PT06 from '@/components/pt06'
 import CH_18 from '@/components/ch_18'
 import PT07 from '@/components/pt07'
 import CH_19 from '@/components/ch_19'
 import CH_20 from '@/components/ch_20'
 import CH_21 from '@/components/ch_21'
 import EPI from '@/components/epi'
 import LOVE_2 from '@/components/love_2'
 import XX from '@/components/xx'
 import PER from '@/components/per'
 import ATA from '@/components/ata'
 import PRAISE from '@/components/praise'
 import ADC from '@/components/adc'
 import COP from '@/components/cop'
 import ATP from '@/components/atp'
 import FOOTNOTE from '@/components/footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/for",
 			"name" : "for",
 			"component" : FOR
 		},
 		{
 			"path" : "/pro",
 			"name" : "pro",
 			"component" : PRO
 		},
 		{
 			"path" : "/pt01",
 			"name" : "pt01",
 			"component" : PT01
 		},
 		{
 			"path" : "/ch_01",
 			"name" : "ch_01",
 			"component" : CH_01
 		},
 		{
 			"path" : "/ch_02",
 			"name" : "ch_02",
 			"component" : CH_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js